import React, { useState, useEffect } from "react";
import { IoIosArrowDropdown } from "react-icons/io";
import { BsPersonCircle } from "react-icons/bs";
import {
  FaRegStar,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileImage,
  FaFileAudio,
  FaFileVideo,
  FaFileArchive,
  FaFileAlt,
  FaFile,
} from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FiPaperclip, FiDownload, FiEdit } from "react-icons/fi";

const getFileIcon = (mimeType) => {
  if (mimeType?.includes("pdf"))
    return <FaFilePdf className="text-red-500" size={20} />;
  if (mimeType?.includes("word"))
    return <FaFileWord className="text-[#5652CF]" size={20} />;
  if (mimeType?.includes("excel"))
    return <FaFileExcel className="text-green-500" size={20} />;
  if (mimeType?.includes("image"))
    return <FaFileImage className="text-yellow-500" size={20} />;
  if (mimeType?.includes("zip") || mimeType?.includes("rar"))
    return <FaFileArchive className="text-gray-500" size={20} />;
  if (mimeType?.includes("audio"))
    return <FaFileAudio className="text-purple-500" size={20} />;
  if (mimeType?.includes("video"))
    return <FaFileVideo className="text-indigo-500" size={20} />;
  return <FaFile className="text-gray-500" size={20} />;
};

const AttachmentItem = ({ messageId, attachment, isOutlook }) => {
  const [hovered, setHovered] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  // const handleDownloadClick = async () => {
  //   if (isDownloading) return; // Prevent double clicks
  //   setIsDownloading(true);

  //   try {
  //     await handleDownload(
  //       messageId,
  //       attachment.attachmentId,
  //       attachment.filename,
  //       userGoogleId,
  //       isOutlook
  //     );
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //   } finally {
  //     setIsDownloading(false); // Reset downloading state
  //   }
  // };

  return (
    <div
      className="text-gray-500 w-40 h-10 py-3 border p-2 rounded-lg shadow-md cursor-pointer inline-flex items-center justify-center"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title={attachment?.filename || attachment?.name}
    >
      {hovered ? (
        <div className="flex gap-4 items-center justify-center h-10 w-40">
          {isDownloading ? (
            <AiOutlineLoading3Quarters
              className="text-gray-600 animate-spin"
              size={16}
            />
          ) : (
            <FiDownload
              // onClick={handleDownloadClick}
              className="text-gray-600 cursor-pointer hover:text-black"
              size={16}
            />
          )}

          <FiPaperclip
            className="text-gray-600 cursor-pointer hover:text-black"
            size={16}
          />
          <FiEdit
            className="text-gray-600 cursor-pointer hover:text-black"
            size={16}
          />
        </div>
      ) : (
        <div className="flex items-center space-x-2 w-full">
          <div className="w-8 h-8 flex items-center justify-center">
            {getFileIcon(attachment?.mimeType || attachment?.type)}{" "}
            {/* Handle both cases */}
          </div>
          <span className="truncate text-sm font-medium">
            {attachment?.filename || attachment?.name} {/* Handle both cases */}
          </span>
        </div>
      )}
    </div>
  );
};

export default function CombinedFeedback({ meetingData = {} }) {
  const [isLoading, setIsLoading] = useState(true);
  // Single state object for both header and planning data
  const [data, setData] = useState({
    mainLabel: "",
    headerStatus: "", // e.g. "Completed"
    timeLabel: "", // e.g. "Feb 26, 2025 | 10:00 AM - 11:30 AM (90 mins)"
    title: "",
    planningStatus: "", // e.g. "High"
    description: "",
    agenda: [],
    attendees: [],
    keyDecisions: [],
    actionableItems: [],
    risks: [],
    attachments: [],
  });

  // State to manage expand/collapse for the additional details (Attendees and Highlighted section)
  const [isExpanded, setIsExpanded] = useState(false);

  // Simulate fetching data from a backend
  useEffect(() => {
    setTimeout(() => {
      // Example: fetched data from API
      // const fetchedData = {
      //   mainLabel: "Client Feedback - Alpha Release",
      //   headerStatus: "Completed",
      //   timeLabel: "Feb 26, 2025 | 10:00 AM - 11:30 AM (90 mins)",
      //   title: "Sprint Planning - March 2025",
      //   planningStatus: "High",
      //   description:
      //     "Discussed Acme Corp.'s experience with the Alpha release. Key concerns were raised about performance issues and missing analytics reports.",
      //   agenda: [
      //     "Review previous sprint outcomes",
      //     "Discuss backlog prioritization",
      //     "Assign tasks and set deadlines",
      //   ],
      //   attendees: [
      //     "JohnDoe",
      //     "Jane Smith",
      //     "Michael Johnson",
      //     "Sam Brown",
      //     "Additional Attendee 1",
      //     "Additional Attendee 2",
      //     "Additional Attendee 3",
      //     "Additional Attendee 4",
      //     "Additional Attendee 5",
      //     "Additional Attendee 6",
      //     "Additional Attendee 7",
      //     "Additional Attendee 8",
      //     "Additional Attendee 9",
      //     "Additional Attendee 10",
      //   ],
      //   keyDecisions: [
      //     "✅ Agreed to prioritize dashboard improvements for next release",
      //     "✅ Scheduled follow-up meeting for March 15",
      //   ],
      //   actionableItems: [
      //     "🔹 Michael to investigate reported performance lags (Due: March 5)",
      //     "🔹 Emily to refine UI responsiveness in mobile view (Due: March 8)",
      //   ],
      //   risks: [
      //     "⚠️ Performance issues on large datasets need urgent attention",
      //   ],
      //   attachments: [
      //     {
      //       "name": "Client_Feedback_Document.pdf",
      //       "type": "pdf"
      //     },
      //     {
      //       "name": "Alpha_Release_Report.txt",
      //       "type": "txt"
      //     }
      //   ],
      // };
      // const fetchedData={
      //   "mainLabel": "Post-Launch Retrospective - Beta Rollout",
      //   "headerStatus": "Completed",
      //   "timeLabel": "March 10, 2025 | 2:00 PM - 3:30 PM (90 mins)",
      //   "title": "Performance Tuning & Roadmap Adjustments",
      //   "planningStatus": "High",
      //   "description": "Analyzed the initial feedback from Beta users. Key concerns included slow load times on mobile and missing data export functionality.",
      //   "agenda": [
      //     "Review Beta rollout feedback",
      //     "Identify critical performance bottlenecks",
      //     "Adjust development roadmap based on findings"
      //   ],
      //   "attendees": [
      //     "Rajesh Kumar (Tech Lead)",
      //     "Priya Sharma (Product Manager)",
      //     "Amit Verma (Backend Developer)",
      //     "Neha Iyer (UI/UX Designer)",
      //     "Vikram Malhotra (Mobile Engineer)",
      //     "Sonia Dutta (QA Engineer)",
      //     "Arun Reddy (Database Admin)",
      //     "Kiran Joshi (DevOps Engineer)",
      //     "Pooja Nair (Customer Success Manager)",
      //     "Manoj Patil (Data Analyst)",
      //     "Reena Mehta (Frontend Developer)",
      //     "Ankit Choudhury (Scrum Master)",
      //     "Swati Saxena (Marketing Manager)",
      //     "Ishaan Pillai (Support Engineer)"
      //   ],
      //   "keyDecisions": [
      //     "✅ Agreed to prioritize database indexing for faster query performance",
      //     "✅ Scheduled an emergency performance testing sprint (March 18 - March 22)"
      //   ],
      //   "actionableItems": [
      //     "🔹 Amit to optimize API response times (Due: March 15)",
      //     "🔹 Neha to refine data export feature for better usability (Due: March 20)"
      //   ],
      //   "risks": [
      //     "⚠️ Mobile performance issues could delay the final release timeline"
      //   ],
      //   "attachments": [
      //     {
      //       "name": "Beta_Feedback_Report.pdf",
      //       "type": "pdf"
      //     },
      //     {
      //       "name": "Performance_Optimization_Notes.txt",
      //       "type": "txt"
      //     }
      //   ]
      const fetchedData = {
        ...meetingData,
      };
      setData(fetchedData);
      setIsLoading(false);
    }, 1000); // Simulated delay
  }, []);

  return (
    <div className="transform transition-transform duration-200 w-full">
      {!isLoading ? (
        <div className="w-full mx-auto bg-zinc-900 shadow-md rounded-xl border border-zinc-700">
          {/* Header Section */}
          <header className="bg-zinc-800 text-zinc-400 p-4 flex items-center rounded-t-xl justify-between">
            <div className="inline-flex items-center border border-zinc-500 rounded-full px-3 py-1 font-semibold">
              {data.mainLabel}
            </div>
            <div className="flex flex-col items-end gap-2">
              {data.headerStatus && (
                <span className="inline-flex items-center gap-1 bg-green-500 text-xs text-white px-3 py-1 rounded-md font-medium">
                  {data.headerStatus}
                </span>
              )}
              {data.timeLabel && (
                <span className="text-xs text-zinc-500">{data.timeLabel}</span>
              )}
            </div>
          </header>

          {/* Planning Section */}
          <div className="p-6">
            <div className="flex items-start justify-between mb-2">
              <h2 className="text-lg font-bold text-zinc-100">{data.title}</h2>
              {data.planningStatus && (
                <span className="inline-block bg-red-500 text-xs text-white font-semibold px-3 py-1 rounded-md">
                  {data.planningStatus}
                </span>
              )}
            </div>

            <p className="mb-4 text-sm text-zinc-400">{data.description}</p>

            <section className="mb-4">
              <h3 className="text-sm font-bold text-zinc-100 mb-1">
                Agenda & Discussion Points
              </h3>
              <ul className="list-disc list-inside text-sm text-zinc-500">
                {data.agenda?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            {/* Toggle Additional Details */}
            <div
              className="flex justify-between items-center cursor-pointer border-t border-zinc-700 pt-4 mb-4"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <h3 className="text-sm font-bold text-zinc-100">
                Additional Details
              </h3>
              <button className="focus:outline-none">
                <IoIosArrowDropdown
                  size={20}
                  className={`text-zinc-500 hover:text-zinc-300 transform transition-transform duration-200 ${
                    isExpanded ? "rotate-180" : "rotate-0"
                  } `}
                />
              </button>
            </div>

            {isExpanded && (
              <>
                <section className="mb-4 bg-zinc-800 p-4 rounded-lg border border-zinc-700">
                  <h3 className="text-sm font-bold text-zinc-100 mb-1">
                    Attendees
                  </h3>
                  <div className="flex flex-wrap gap-2 bg-zinc-800 p-2 pl-0 pr-0">
                    {data.attendees?.map((attendee, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-2 bg-zinc-900 border border-zinc-700 shadow-sm px-3 py-2 rounded-lg"
                      >
                        <BsPersonCircle className="w-6 h-6 text-zinc-400" />
                        <span className="text-sm font-medium text-zinc-100">
                          {attendee}
                        </span>
                      </div>
                    ))}
                  </div>
                </section>

                <section className="mb-4 bg-zinc-800 p-4 rounded-lg border border-zinc-700">
                  <h3 className="text-sm font-bold text-zinc-100 mb-1">
                    Key Decisions Made
                  </h3>
                  <ul className="list-disc list-inside text-sm text-zinc-500">
                    {data.keyDecisions?.map((decision, index) => (
                      <li key={index}>{decision}</li>
                    ))}
                  </ul>
                </section>

                <section className="mb-4 bg-zinc-800 p-4 rounded-lg border border-zinc-700">
                  <h3 className="text-sm font-bold text-zinc-100 mb-1">
                    Actionable Items
                  </h3>
                  <ul className="list-disc list-inside text-sm text-zinc-500">
                    {data.actionableItems?.map((action, index) => (
                      <li key={index}>{action}</li>
                    ))}
                  </ul>
                </section>

                <section className="mb-4 bg-zinc-800 p-4 rounded-lg border border-zinc-700">
                  <h3 className="text-sm font-bold text-zinc-100 mb-1">
                    Risks
                  </h3>
                  <ul className="list-disc list-inside text-sm text-zinc-500">
                    {data.risks?.map((risk, index) => (
                      <li key={index}>{risk}</li>
                    ))}
                  </ul>
                </section>

                <section className="mb-4 bg-zinc-800 p-4 rounded-lg border border-zinc-700">
                  <h3 className="text-sm font-bold text-zinc-100 mb-1">
                    Attachments
                  </h3>
                  <div className="flex flex-wrap gap-2 bg-zinc-800 p-2 pl-0 pr-0">
                    {data.attachments?.map((attachment, index) => (
                      <AttachmentItem key={index} attachment={attachment} />
                    ))}
                  </div>
                </section>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="w-full mx-auto bg-zinc-900 shadow-md rounded-xl border border-zinc-700 ">
          {/* Header Section */}
          <header className="bg-zinc-800 p-4 flex items-center rounded-t-xl justify-between">
            <div className="h-6 w-24 bg-zinc-500 rounded-full animate-pulse "></div>
            <div className="flex flex-col items-end gap-2">
              <div className="h-5 w-16 bg-zinc-500 rounded-md animate-pulse "></div>
              <div className="h-4 w-20 bg-zinc-500 rounded animate-pulse"></div>
            </div>
          </header>

          {/* Planning Section */}
          <div className="p-6">
            <div className="flex items-start justify-between mb-2">
              <div className="h-6 w-48 bg-zinc-500 animate-pulse rounded"></div>
              <div className="h-5 w-20 bg-zinc-500 animate-pulse rounded-md"></div>
            </div>

            <div className="h-4 w-full bg-zinc-500 animate-pulse rounded mb-2"></div>
            <div className="h-4 w-3/4 bg-zinc-500 animate-pulse rounded mb-4"></div>

            <section className="mb-4">
              <div className="h-5 w-40 bg-zinc-500 animate-pulse rounded mb-2"></div>
              <ul className="space-y-2">
                <li className="h-4 w-3/4 bg-zinc-500 animate-pulse rounded"></li>
                <li className="h-4 w-2/3 bg-zinc-500 animate-pulse rounded"></li>
              </ul>
            </section>

            {/* Toggle Additional Details */}
            <div className="flex justify-between items-center border-t border-zinc-700 pt-4 mb-4">
              <div className="h-5 w-40 bg-zinc-500 animate-pulse rounded"></div>
              <div className="h-5 w-5 bg-zinc-500 animate-pulse rounded-full"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}